export default __webpack_public_path__ + "static/media/default-logo.73cd6ca4.svg";